import type { Theme } from "../types";

/** Dark themes: zinc-dark through monokai */
export const bundle02: Theme[] = [
  {
    colors: {
      accent: "oklch(0.274 0.006 286.033)",
      accentForeground: "oklch(0.985 0 0)",
      background: "oklch(0.141 0.005 285.823)",
      border: "oklch(1 0 0 / 10%)",
      card: "oklch(0.21 0.006 285.885)",
      cardForeground: "oklch(0.985 0 0)",
      chartColors: [
        "oklch(0.488 0.243 264.376)",
        "oklch(0.696 0.17 162.48)",
        "oklch(0.769 0.188 70.08)",
        "oklch(0.627 0.265 303.9)",
        "oklch(0.645 0.246 16.439)",
      ],
      destructive: "oklch(0.704 0.191 22.216)",
      foreground: "oklch(0.985 0 0)",
      input: "oklch(1 0 0 / 15%)",
      muted: "oklch(0.274 0.006 286.033)",
      mutedForeground: "oklch(0.705 0.015 286.067)",
      popover: "oklch(0.21 0.006 285.885)",
      popoverForeground: "oklch(0.985 0 0)",
      primary: "oklch(0.92 0.004 286.32)",
      primaryForeground: "oklch(0.21 0.006 285.885)",
      ring: "oklch(0.552 0.016 285.938)",
      secondary: "oklch(0.274 0.006 286.033)",
      secondaryForeground: "oklch(0.985 0 0)",
      sidebar: "oklch(0.21 0.006 285.885)",
      sidebarAccent: "oklch(0.274 0.006 286.033)",
      sidebarAccentForeground: "oklch(0.985 0 0)",
      sidebarBorder: "oklch(1 0 0 / 10%)",
      sidebarForeground: "oklch(0.985 0 0)",
      sidebarPrimary: "oklch(0.488 0.243 264.376)",
      sidebarPrimaryForeground: "oklch(0.985 0 0)",
      sidebarRing: "oklch(0.552 0.016 285.938)",
    },
    isDark: true,
    label: "Zinc Dark",
    name: "zinc-dark",
    pair: "zinc-light",
    swatches: ["#18181b", "#fafafa", "#71717a", "#27272a"],
  },
  {
    colors: {
      accent: "oklch(0.32 0.01 250)",
      accentForeground: "oklch(0.87 0.01 90)",
      background: "oklch(0.26 0.007 250)",
      border: "oklch(1 0 0 / 10%)",
      card: "oklch(0.24 0.007 250)",
      cardForeground: "oklch(0.87 0.01 90)",
      chartColors: [
        "oklch(0.78 0.17 85)",
        "oklch(0.696 0.17 162.48)",
        "oklch(0.645 0.246 16.439)",
        "oklch(0.627 0.265 303.9)",
        "oklch(0.769 0.188 70.08)",
      ],
      destructive: "oklch(0.704 0.191 22.216)",
      foreground: "oklch(0.87 0.01 90)",
      input: "oklch(1 0 0 / 15%)",
      muted: "oklch(0.3 0.007 250)",
      mutedForeground: "oklch(0.62 0.01 90)",
      popover: "oklch(0.24 0.007 250)",
      popoverForeground: "oklch(0.87 0.01 90)",
      primary: "oklch(0.78 0.17 85)",
      primaryForeground: "oklch(0.2 0.007 250)",
      ring: "oklch(0.78 0.17 85)",
      secondary: "oklch(0.3 0.007 250)",
      secondaryForeground: "oklch(0.87 0.01 90)",
      sidebar: "oklch(0.22 0.007 250)",
      sidebarAccent: "oklch(0.32 0.01 250)",
      sidebarAccentForeground: "oklch(0.87 0.01 90)",
      sidebarBorder: "oklch(1 0 0 / 10%)",
      sidebarForeground: "oklch(0.87 0.01 90)",
      sidebarPrimary: "oklch(0.78 0.17 85)",
      sidebarPrimaryForeground: "oklch(0.2 0.007 250)",
      sidebarRing: "oklch(0.78 0.17 85)",
    },
    isDark: true,
    label: "Serika Dark",
    name: "serika-dark",
    pair: "serika-light",
    swatches: ["#323437", "#e2b714", "#d1d0c5", "#2c2e31"],
  },
  {
    colors: {
      accent: "oklch(0.38 0.025 280)",
      accentForeground: "oklch(0.94 0.01 300)",
      background: "oklch(0.24 0.015 280)",
      border: "oklch(1 0 0 / 10%)",
      card: "oklch(0.27 0.018 280)",
      cardForeground: "oklch(0.94 0.01 300)",
      chartColors: [
        "oklch(0.72 0.18 300)",
        "oklch(0.73 0.2 345)",
        "oklch(0.75 0.17 135)",
        "oklch(0.7 0.15 260)",
        "oklch(0.65 0.22 25)",
      ],
      destructive: "oklch(0.68 0.2 15)",
      foreground: "oklch(0.94 0.01 300)",
      input: "oklch(1 0 0 / 15%)",
      muted: "oklch(0.35 0.02 280)",
      mutedForeground: "oklch(0.65 0.015 280)",
      popover: "oklch(0.27 0.018 280)",
      popoverForeground: "oklch(0.94 0.01 300)",
      primary: "oklch(0.72 0.18 300)",
      primaryForeground: "oklch(0.2 0.015 280)",
      ring: "oklch(0.72 0.18 300)",
      secondary: "oklch(0.35 0.02 280)",
      secondaryForeground: "oklch(0.94 0.01 300)",
      sidebar: "oklch(0.22 0.015 280)",
      sidebarAccent: "oklch(0.38 0.025 280)",
      sidebarAccentForeground: "oklch(0.94 0.01 300)",
      sidebarBorder: "oklch(1 0 0 / 10%)",
      sidebarForeground: "oklch(0.94 0.01 300)",
      sidebarPrimary: "oklch(0.72 0.18 300)",
      sidebarPrimaryForeground: "oklch(0.2 0.015 280)",
      sidebarRing: "oklch(0.72 0.18 300)",
    },
    isDark: true,
    label: "Dracula",
    name: "dracula",
    pair: "lavender-light",
    swatches: ["#282a36", "#bd93f9", "#ff79c6", "#44475a"],
  },
  {
    colors: {
      accent: "oklch(0.4 0.025 240)",
      accentForeground: "oklch(0.9 0.01 230)",
      background: "oklch(0.27 0.015 240)",
      border: "oklch(1 0 0 / 10%)",
      card: "oklch(0.3 0.018 240)",
      cardForeground: "oklch(0.9 0.01 230)",
      chartColors: [
        "oklch(0.77 0.08 210)",
        "oklch(0.7 0.06 230)",
        "oklch(0.65 0.2 20)",
        "oklch(0.75 0.15 100)",
        "oklch(0.72 0.15 300)",
      ],
      destructive: "oklch(0.65 0.2 20)",
      foreground: "oklch(0.9 0.01 230)",
      input: "oklch(1 0 0 / 15%)",
      muted: "oklch(0.36 0.02 240)",
      mutedForeground: "oklch(0.65 0.02 230)",
      popover: "oklch(0.3 0.018 240)",
      popoverForeground: "oklch(0.9 0.01 230)",
      primary: "oklch(0.77 0.08 210)",
      primaryForeground: "oklch(0.22 0.015 240)",
      ring: "oklch(0.77 0.08 210)",
      secondary: "oklch(0.36 0.02 240)",
      secondaryForeground: "oklch(0.9 0.01 230)",
      sidebar: "oklch(0.25 0.015 240)",
      sidebarAccent: "oklch(0.4 0.025 240)",
      sidebarAccentForeground: "oklch(0.9 0.01 230)",
      sidebarBorder: "oklch(1 0 0 / 10%)",
      sidebarForeground: "oklch(0.9 0.01 230)",
      sidebarPrimary: "oklch(0.77 0.08 210)",
      sidebarPrimaryForeground: "oklch(0.22 0.015 240)",
      sidebarRing: "oklch(0.77 0.08 210)",
    },
    isDark: true,
    label: "Nord",
    name: "nord-dark",
    pair: "ocean-light",
    swatches: ["#2e3440", "#88c0d0", "#81a1c1", "#3b4252"],
  },
  {
    colors: {
      accent: "oklch(0.36 0.015 100)",
      accentForeground: "oklch(0.94 0.01 90)",
      background: "oklch(0.22 0.012 100)",
      border: "oklch(1 0 0 / 10%)",
      card: "oklch(0.25 0.012 100)",
      cardForeground: "oklch(0.94 0.01 90)",
      chartColors: [
        "oklch(0.6 0.25 350)",
        "oklch(0.8 0.2 128)",
        "oklch(0.7 0.17 65)",
        "oklch(0.65 0.2 260)",
        "oklch(0.72 0.15 195)",
      ],
      destructive: "oklch(0.6 0.25 350)",
      foreground: "oklch(0.94 0.01 90)",
      input: "oklch(1 0 0 / 15%)",
      muted: "oklch(0.32 0.012 100)",
      mutedForeground: "oklch(0.6 0.012 90)",
      popover: "oklch(0.25 0.012 100)",
      popoverForeground: "oklch(0.94 0.01 90)",
      primary: "oklch(0.6 0.25 350)",
      primaryForeground: "oklch(0.95 0.01 90)",
      ring: "oklch(0.6 0.25 350)",
      secondary: "oklch(0.32 0.012 100)",
      secondaryForeground: "oklch(0.94 0.01 90)",
      sidebar: "oklch(0.2 0.012 100)",
      sidebarAccent: "oklch(0.36 0.015 100)",
      sidebarAccentForeground: "oklch(0.94 0.01 90)",
      sidebarBorder: "oklch(1 0 0 / 10%)",
      sidebarForeground: "oklch(0.94 0.01 90)",
      sidebarPrimary: "oklch(0.6 0.25 350)",
      sidebarPrimaryForeground: "oklch(0.95 0.01 90)",
      sidebarRing: "oklch(0.6 0.25 350)",
    },
    isDark: true,
    label: "Monokai",
    name: "monokai",
    pair: "tangerine",
    swatches: ["#272822", "#f92672", "#a6e22e", "#49483e"],
  },
];
